import React, { useRef, useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";

import "./ThreatTimeLineChart.css";

ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement, Tooltip, Legend, Filler);

export const ThreatTimelineChart = ({ mode, data, loading, timeFilter, setTimeFilter }) => {
  const chartRef = useRef(null);
  const [gradientOrange, setGradientOrange] = useState("rgba(249,115,22,0.1)");
  const [gradientBlue, setGradientBlue] = useState("rgba(59,130,246,0.1)");

  const isDark = mode === "dark";

  useEffect(() => {
    const chart = chartRef.current;
    if (chart && !loading) {
      const ctx = chart.ctx;
      const chartArea = chart.chartArea;

      if (chartArea) {
        const orangeGrad = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
        orangeGrad.addColorStop(0, "rgba(249, 115, 22, 0.3)");
        orangeGrad.addColorStop(1, "rgba(249, 115, 22, 0.0)");
        setGradientOrange(orangeGrad);

        const blueGrad = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
        blueGrad.addColorStop(0, "rgba(59, 130, 246, 0.3)");
        blueGrad.addColorStop(1, "rgba(59, 130, 246, 0.0)");
        setGradientBlue(blueGrad);
      }
    }
  }, [data, loading]);

  // console.log((`this id data ${data}`));
  

  if (loading) {
    return (
      <div className={`chart-container skeleton-container ${isDark ? "chart-dark" : "chart-light"}`}>
        <div className="skeleton-header">
            <div className="skeleton-text skeleton-title"></div>
            <div className="skeleton-text skeleton-filter"></div>
        </div>
        <div className="skeleton-chart-body">
            <div className="skeleton-line-mock"></div>
        </div>
      </div>
    );
  }

  const chartData = {
    labels: data.map((item) => item.time),
    datasets: [
      {
        label: "Threat Score",
        data: data.map((item) => item.threat),
        borderColor: "#f97316",
        backgroundColor: gradientOrange,
        yAxisID: "y1",
        pointBackgroundColor: "#fff",
        pointBorderColor: "#f97316",
        pointBorderWidth: 2,
        pointRadius: 3,
        pointHoverRadius: 6,
        borderWidth: 2,
        tension: 0.4,
        fill: true,
      },
      {
        label: "Total Events",
        data: data.map((item) => item.total),
        borderColor: "#3b82f6",
        backgroundColor: gradientBlue,
        yAxisID: "y2",
        pointBackgroundColor: "#fff",
        pointBorderColor: "#3b82f6",
        pointBorderWidth: 2,
        pointRadius: 3,
        pointHoverRadius: 6,
        borderWidth: 2,
        tension: 0.4,
        fill: true,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          usePointStyle: true,
          color: isDark ? "#94a3b8" : "#64748b",
          padding: 20,
        },
      },
      tooltip: {
        mode: 'index',
        intersect: false,
        backgroundColor: isDark ? "#1e293b" : "#ffffff",
        titleColor: isDark ? "#f8fafc" : "#1e293b",
        bodyColor: isDark ? "#cbd5e1" : "#475569",
        borderColor: "rgba(249, 115, 22, 0.2)",
        borderWidth: 1,
        padding: 12,
        cornerRadius: 8,
      }
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: { color: isDark ? "#64748b" : "#94a3b8", maxRotation: 0 }
      },
      y1: {
        position: "left",
        max: 100,
        grid: { color: isDark ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.05)" },
        ticks: { color: "#f97316" }
      },
      y2: {
        position: "right",
        grid: { display: false },
        ticks: { color: "#3b82f6" }
      }
    }
  };

  return (
    <div className={`chart-container ${isDark ? "chart-dark" : "chart-light"}`}>
      <div className="chart-header-modern">
        <div className="chart-info">
          <h3 className="chart-title">Real-time ITDR events and threat score monitoring</h3>
          <p className="chart-subtitle">Anomalies vs Volume</p>
        </div>
        <div className="chart-actions">
          <select
            className="filter-select-modern"
            value={timeFilter}
            onChange={(e) => setTimeFilter(e.target.value)}
          >
            <option value="7d">Last 7 Days</option>
            <option value="24h">Last 24 Hours</option>
            <option value="today">Today</option>
          </select>
        </div>
      </div>
      
      <div className="chart-body-wrapper">
        <Line ref={chartRef} data={chartData} options={options} />
      </div>
    </div>
  );
};